import { BulkUpdateSpaceControlBookingDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

export const useUpdateSpaceBooking: OneCreationActionResolver = () => {
  const { employee } = useCurrentSession()

  const [updateBooking, { loading }] = useMutation(BulkUpdateSpaceControlBookingDocument, {
    extractorFn: (data) => data.spaceControlMutations.bulkUpdateSpacecontrolBooking,
    errorPolicy: 'all',
  })

  const updateBookingHandler = async (args: {
    ids: string[]
    date: string
    workSpaceId: string
    slots: number[]
    capacity?: number
    employeeId?: string
  }) => {
    const employeeId = args.employeeId ?? employee?.id
    if (!employeeId) {
      return
    }

    const result = await updateBooking({
      variables: {
        ids: args.ids,
        date: args.date,
        workSpaceId: String(args.workSpaceId),
        slots: args.slots,
        capacity: args.capacity ?? undefined,
        employeeId: String(employeeId),
      },
    })

    return handleResult(result, (_errors) => {})
  }

  return {
    resolver: updateBookingHandler,
    loading,
  }
}
